import * as Common from "../../commons/common"

export class Student {
  id: number
  user_id: number
  student_num: number
  student_name: string
  nendo: number
  grade_id: number
  room_id: number
  number: number
  is_exists_result_image: boolean = false
  score: number
  saitenCompletedFieldCount: number
  checked: boolean = false
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  fieldActivities: FieldActivity[] = new Array<FieldActivity>()
  base64ScanImages: string[] = new Array<string>();
  base64ResultImages: string[] = new Array<string>();

  constructor(student: any, sheetActivities: SheetActivity[], fieldActivities: FieldActivity[], exists_result_image_student_nos: number[]){
    this.id = student.id;
    this.user_id = student.user_id;
    this.student_num = student.student_num;
    this.student_name = student.name;
    this.nendo = student.nendo;
    this.grade_id = student.grade_id;
    this.room_id = student.room_id;
    this.number = student.number;
    this.is_exists_result_image = exists_result_image_student_nos.filter(x => x == this.user_id).length > 0;
    this.sheetActivities = sheetActivities.filter(x => x.student_id == this.user_id);
    this.sheetActivities.forEach(x => {
      this.fieldActivities = this.fieldActivities.concat(fieldActivities.filter(y => y.sheet_activity_id == x.id));
    });
    this.saitenCompletedFieldCount = this.fieldActivities.filter(x => x.saiten_completed).length;

    // 得点設定（０点の生徒と欠席生徒を区別するため）
    this.score = Common.sumArray(this.fieldActivities.map(x => x.score == null ? 0 : x.score));
    this.score = this.score;
  }
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number
  correct_state: number
  saiten_completed: boolean
  
  constructor(fieldActiviby: any){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    this.score = fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.saiten_completed = fieldActiviby.saiten_completed;
  }
}

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean
  exec_date: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
    this.exec_date = sheet.exec_date;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  FieldActivities: FieldActivity[] = new Array<FieldActivity>()
  isSaitenCompleted: boolean
  firstSaitenCompletedCount: number
  scoring_type: number | null

  constructor(sheetField: any, fieldActivities: FieldActivity[]){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.allotCache = sheetField.allot;
    this.FieldActivities = fieldActivities.filter(x => x.sheet_field_id == this.id);
    const totalScore: number = Common.sumArray(this.FieldActivities.map(x => x.score == null ? 0 : x.score));
    this.scoreAverage = Number((totalScore / this.FieldActivities.length).toFixed(1));
    this.scoreRate = Math.round(totalScore / (this.allot * this.FieldActivities.length) * 100);
    this.isSaitenCompleted = this.FieldActivities.filter(x => !x.saiten_completed).length == 0;
    this.firstSaitenCompletedCount = this.FieldActivities.filter(x => x.saiten_completed).length;
    this.isSaitenCompleted = this.firstSaitenCompletedCount == this.FieldActivities.length;
    this.scoring_type = sheetField.scoring_type;
  }
}

export class ScoreOption {
  value: number
  text: string

  constructor(value: number, text: string){
    this.value = value;
    this.text = text;
  }
}